import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Calculator from './components/Calculator';
import FeaturesGrid from './components/FeaturesGrid';
import SystemDifference from './components/SystemDifference';
import MidPageCTA from './components/MidPageCTA';
import Testimonials from './components/Testimonials';
import RiskReversal from './components/RiskReversal';
import FounderStory from './components/FounderStory';
import Urgency from './components/Urgency';
import Marketplace from './components/Marketplace';
import WheelSection from './components/WheelSection';
import Pricing from './components/Pricing';
import ComparisonChart from './components/ComparisonChart';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import ProofOfWork from './components/ProofOfWork';
import SocialProofWidget from './components/SocialProofWidget';
import ExitIntent from './components/ExitIntent';
import LeadForm from './components/LeadForm';
import TrustBadges from './components/TrustBadges';
import ScrollToTop from './components/ScrollToTop';

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#0F1419] text-white selection:bg-[#FF6B35] selection:text-white">
      {/* Background Gradient - Earthy Tones */}
      <div className="fixed inset-0 bg-gradient-to-br from-[#0F1419] via-[#1A4D2E]/5 to-[#4E3629]/5 -z-10" />
      
      <Navbar />
      <SocialProofWidget />
      <ScrollToTop />
      <ExitIntent />
      
      <main>
        <Hero />
        <Calculator />
        <Urgency />
        <SystemDifference />
        <FeaturesGrid />
        <FounderStory />
        <MidPageCTA />
        <Testimonials />
        <ProofOfWork />
        <WheelSection />
        <Marketplace />
        <ComparisonChart />
        <Pricing />
        <TrustBadges />
        <LeadForm />
        <RiskReversal />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default App;